import { notification } from 'ui-lib';

export const PermissionDenied = (message: string): void => {
    return notification.error({
        message: 'Permission Denied',
        description: message
    });
};
export const notifyManageDeviceGroupPermissionDenied = (): void => {
    return notification.error({
        message: 'Permission Denied',
        description: 'You do not have permission to manage device groups'
    });
};

export const notifyEditDeviceAttributePermissionDenied = (attributeName: string): void => {
    return notification.error({
        message: 'Permission Denied',
        description: `You do not have permission to edit device attribute ${attributeName}`
    });
};
export const notifyMoveDevicesPermissionDenied = (): void => {
    return notification.error({
        message: 'Permission Denied',
        description: 'You do not have permission to move devices'
    });
};